import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import "../../CSS/WorkExperience.css";

import WorkExpStepper from "./WorkExpStepper";

import { AppContext } from "../Context.js";
export default function WorkExperience({ id }) {
  const [itemSnapped] = useContext(AppContext);

  return (
    <React.Fragment>
      <div
        className={itemSnapped === "WorkExperience" ? "vanish" : "projects"}
        id={id}
      >
        <Grid container spacing={0} className="bgwe">
          <Grid item md={12} sm={12} xs={12}>
            <div className="titleDiv">
              <h1 className="sectionsTitle">Work Experience</h1>
            </div>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <WorkExpStepper />
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}
